"use client";

import { Footer } from "@/components/footer";
import { SolutionsFirst } from "@/components/page/solutions/first";
import { SolutionsRemote } from "@/components/page/solutions/remote";
import { AutofitPageWrapper } from "@/components/AutofitPageWrapper";
import { useIsMobile } from "@/app/hooks/useIsMobile";
import { MobileFooter } from "@/components/mobile-footer";
import { HeaderMobile } from "@/components/header-mobile";
import { useEffect } from "react";
import { SolutionsMobileFirst } from "@/components/page/solutions-mobile/first";
import { SolutionsMobileSecond } from "@/components/page/solutions-mobile/second";

function useSolutionsScroll() {
  useEffect(() => {
    const headerHeight = 64;

    const tryScrollToId = (id: string) => {
      const targetElement = document.getElementById(id);
      const scrollContainer = document.querySelector(
        "[data-scroll-ref]"
      ) as HTMLElement | null;

      if (!targetElement || !scrollContainer) return false;

      const targetRect = targetElement.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      const currentScrollTop = scrollContainer.scrollTop;
      const targetOffsetFromTop = targetRect.top - containerRect.top;

      const nextScrollTop =
        currentScrollTop + targetOffsetFromTop - headerHeight;
      scrollContainer.scrollTo({
        top: Math.max(0, nextScrollTop),
        behavior: "smooth",
      });

      return true;
    };

    const run = () => {
      const scrollTarget = sessionStorage.getItem("solutionsScrollTarget");
      if (!scrollTarget) return;

      sessionStorage.removeItem("solutionsScrollTarget");

      let retryCount = 0;
      const maxRetries = 30;

      const tick = () => {
        const ok = tryScrollToId(scrollTarget);
        if (!ok && retryCount < maxRetries) {
          retryCount++;
          setTimeout(tick, 200);
        }
      };

      setTimeout(tick, 300);
    };

    run();

    window.addEventListener("solutions-scroll", run);
    return () => {
      window.removeEventListener("solutions-scroll", run);
    };
  }, []);
}

export default function SolutionsPageClient() {
  const isMobile = useIsMobile();
  useSolutionsScroll();

  if (isMobile === null)
    return (
      <div
        className="w-screen h-screen"
        style={{ background: "linear-gradient(135deg, rgba(229,253,255,1) 2.89%, rgba(185,242,250,1) 33.17%, rgba(79,120,255,1) 97.6%)" }}
      />
    );

  if (isMobile) {
    return (
      <div className="flex flex-col w-full h-screen overflow-y-auto">
        <HeaderMobile />
        <SolutionsMobileFirst />
        <SolutionsMobileSecond />
        <MobileFooter />
        <div className="h-[20px] min-h-[20px]" />
      </div>
    );
  }

  return (
    <AutofitPageWrapper>
      <SolutionsFirst />
      <SolutionsRemote />
      <Footer />
    </AutofitPageWrapper>
  );
}
